/*
 * Service to store history of the states visted in the app
 */
angular.module('tgaAdmin').service('stateHistoryService', function stateHistoryService() {
  const history = [];
  this.get = () => history;
  this.previous = () => {
    const { length } = history;
    return length ? history[length - 1] : '';
  };
  this.add = (name) => {
    history.push(name);
    // if we get above history threshold then half the history
    if (history.length > 200) {
      history.splice(0, 100);
    }
  };
});
